import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="w-full bg-[#0A0A0A] py-16 px-4 border-t border-[#16161F]" data-id="element-248">
      <div className="max-w-2xl mx-auto" data-id="element-249">
        <div className="bg-[#16161F] border border-[#ef4444] rounded-3xl p-8 sm:p-10 text-center shadow-2xl relative overflow-hidden" data-id="element-250">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#ef4444] to-[#fca5a5]" data-id="element-251" />

          <p className="text-[#ef4444] text-xs sm:text-sm font-black uppercase tracking-widest mb-4" data-id="element-252">
            ⏰ Limited-time offer
          </p>

          <h2 className="text-2xl sm:text-4xl font-black text-white mb-8 tracking-tight" data-id="element-253">
            Launch Price Ends In:
          </h2>

          <div className="mb-8" data-id="element-254">
            <CountdownTimer size="lg" blinking={true} data-id="element-255" />
          </div>

          <p className="text-white text-base sm:text-lg font-bold mb-8" data-id="element-256">
            After that, the price goes up and bonuses are removed.
          </p>

          <div className="max-w-sm mx-auto" data-id="element-257">
            <div className="w-full bg-[#0A0A0A] rounded-full h-4 overflow-hidden border border-[#ef4444]/30 mb-3" data-id="element-258">
              <div className="h-full rounded-full bg-gradient-to-r from-[#ef4444] to-[#fca5a5]" style={{
              width: '72%'
            }} data-id="element-259" />
            </div>
            <div className="flex items-center justify-between px-1" data-id="element-260">
              <span className="text-[#ef4444] font-black text-xs uppercase tracking-wider" data-id="element-261">
                🔴 Limited spots
              </span>
              <span className="text-[#B0B0C0] font-bold text-xs uppercase tracking-wider" data-id="element-262">
                72% claimed
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}